import firebase from 'firebase'


export const FETCH_TEXT = 'FETCH_TEXT'
export const STORE_TEXT = 'STORE_TEXT'
export const UPDATE_TEXT = 'UPDATE_TEXT'


function getRef(assessmentId, activityId,cpId) {
  return firebase.firestore()
  .collection('assessmentsByRater').doc(assessmentId)
  .collection('answers').doc(activityId)
  .collection('competencies').doc(cpId)
}
 
export function fetchText(assessmentId, activityId,cpId) {
  return (dispatch) => {
    getRef(assessmentId, activityId,cpId).get().then(doc =>  
      dispatch({type: FETCH_TEXT, id: cpId, data: doc.data()}) 
    )
  }
}

export function storeText(assessmentId, activityId,cpId,text) {
  return (dispatch) => {
    getRef(assessmentId, activityId,cpId).set({text})
    .then( data => dispatch({type: STORE_TEXT, id: cpId, text: text}))
  }
}

export function updateText(assessmentId, activityId,cpId,text) {
  return (dispatch) => {
    getRef(assessmentId, activityId,cpId).set({text})
    .then( data => dispatch({type: UPDATE_TEXT, id: cpId, text: text}))
  }
}




/*
export function selectActivity(activity) {
    return (dispatch, getState) => {
      const selectedAssessment = getState().selectedAssessment
      const cpRef = firebase.firestore()
        .collection('assessmentsByRater').doc(selectedAssessment.id)
        .collection('answers').doc(activity.id)
        .collection('competencies')
      const cpRefs = activity.data.competencies.map(cp => 
        cpRef.doc(cp.id).get().then(doc => ({ id: doc.id, data: doc.data()})  ) )
      const cpRefsPromise = Promise.all(cpRefs).then(cps => cps.reduce( (acc,curr) => ({[curr.id]: curr.data}) ,{}  ) )
  
      const promises = activity.data.competencies.map(cp => cp.get().then(doc => ({  id: doc.id,  data:doc.data() }) ))
      const cpsPromise = Promise.all(promises)
  
      Promise.all([cpRefsPromise,cpsPromise]).then(([cpRefs,cps]) =>
        cps.map(cp =>  { cp.data.answerText = cpRefs[cp.id].text; return cp.data })
      )
      .then(cps => dispatch(loadCps({id: activity.id, competencies: cps})))
  
    }
  
  }


export const UPDATE_TEXT = 'assessments/UPDATE_TEXT'
export function updateAnswersText(text,levelId,store) {
  return (dispatch,getState) => {
    
    let selectedAssessment = getState().selectedAssessment
    let answers = selectedAssessment.answers
    const activityId = getState().selectedActivity.id


    const found = answers.find( answer => answer.activityId === activityId && answer.levelId === levelId)
    if (found) {
        answers = answers.map( answer => {
            if (answer.activityId === activityId && answer.levelId === levelId) {
                answer.text = text
            }
            return answer
        })
    }
    selectedAssessment.answers = answers
    store.firestore.update({ collection:'assessmentsByRater', doc: selectedAssessment.id },{answers})
    .catch(error => {
      dispatch({type: 'ERROR', levelId: levelId ,message: error })
    })

    dispatch({
      type: UPDATE_TEXT,
      assessment: selectedAssessment
    })
  }
}

  */



// WEBPACK FOOTER //
// ./src/modules/notes/actions.js